<template>
  <button
    :id="id"
    class="roomie-chip-selector"
    :class="setClasses"
    tabindex="0"
    @click="reactToClick">
    <RoomieIcon
      v-if="$slots.icon"
      class="roomie-chip-selector__icon"
      :class="[`roomie-chip-selector__${variant}__icon`, { [`roomie-chip-selector__${variant}--selected__icon`]: selected, [`roomie-chip-selector__${variant}--disabled__icon`]: disabled }]">
      <slot name="icon" />
    </RoomieIcon>
    <slot name="content" />
  </button>
</template>

<script>
import RoomieIcon from '../RoomieIcon/index.vue'
import { ICON_PLACEMENT, SIZE, VARIANT_LIST } from './utils'

export default {
  name: 'RoomieChipSelector',
  components: {
    RoomieIcon
  },
  props: {
    id: {
      type: String,
      default: 'roomie-chip-selector',
      required: true
    },
    iconPlacement: {
      type: String,
      default: ICON_PLACEMENT.left,
      validator: (value) => Object.values(ICON_PLACEMENT).includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: undefined
    },
    size: {
      type: String,
      default: 'sm',
      validator: (value) => Object.keys(SIZE).includes(value),
      required: false
    },
    variant: {
      type: String,
      default: VARIANT_LIST.NEUTRAL,
      validator: (value) => Object.values(VARIANT_LIST).includes(value)
    },
  },
  emits:['click'],
  data: function () {
    return {
      selected: this.isSelected ?? false
    }
  },
  computed: {
    setClasses() {
      return {
        [`roomie-chip-selector__${this.variant}--selected`]: this.selected,
        [`roomie-chip-selector__${this.variant}--disabled`]: this.disabled,
        'flex-row-reverse': this.iconPlacement === 'right',
        'roomie-chip-selector--sm' : this.size === 'sm',
        'roomie-chip-selector--md' : this.size === 'md',
        'roomie-chip-selector__neutral' : this.variant === VARIANT_LIST.NEUTRAL,
        'roomie-chip-selector__pine' : this.variant === VARIANT_LIST.PINE
      }
    }
  },
  watch: {
    disabled() {
      this.selected = false
    },
    isSelected() {
      this.selected = this.isSelected
    }
  },
  methods: {
    reactToClick() {
      this.selected = this.isSelected ?? (!this.selected && !this.disabled)
      this.$emit('click', { selected: this.selected })
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
